var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 11.5,
    fill: "#F9F9F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 11.5,
    stroke: "#E6E6E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7946 24.4944C28.2743 23.5981 27.5009 21.0622 27.5009 17.75C27.5009 15.7609 26.7107 13.8532 25.3042 12.4467C23.8976 11.0402 21.99 10.25 20.0009 10.25C18.0117 10.25 16.1041 11.0402 14.6976 12.4467C13.291 13.8532 12.5009 15.7609 12.5009 17.75C12.5009 21.0631 11.7265 23.5981 11.2062 24.4944C11.0733 24.7222 11.0029 24.9811 11.002 25.2449C11.0011 25.5086 11.0697 25.768 11.201 25.9967C11.3323 26.2255 11.5216 26.4156 11.7498 26.5478C11.9781 26.6801 12.2371 26.7498 12.5009 26.75H16.3268C16.4998 27.5967 16.96 28.3577 17.6295 28.9042C18.299 29.4507 19.1367 29.7492 20.0009 29.7492C20.8651 29.7492 21.7028 29.4507 22.3722 28.9042C23.0417 28.3577 23.5019 27.5967 23.6749 26.75H27.5009C27.7645 26.7496 28.0235 26.6798 28.2516 26.5475C28.4796 26.4151 28.6688 26.225 28.8 25.9963C28.9312 25.7676 28.9998 25.5083 28.9988 25.2446C28.9979 24.9809 28.9274 24.7222 28.7946 24.4944ZM20.0009 28.25C19.5357 28.2499 19.082 28.1055 18.7022 27.8369C18.3225 27.5683 18.0353 27.1886 17.8802 26.75H22.1215C21.9664 27.1886 21.6793 27.5683 21.2995 27.8369C20.9197 28.1055 20.466 28.2499 20.0009 28.25ZM12.5009 25.25C13.2227 24.0087 14.0009 21.1325 14.0009 17.75C14.0009 16.1587 14.633 14.6326 15.7582 13.5074C16.8834 12.3821 18.4096 11.75 20.0009 11.75C21.5922 11.75 23.1183 12.3821 24.2435 13.5074C25.3687 14.6326 26.0009 16.1587 26.0009 17.75C26.0009 21.1297 26.7771 24.0059 27.5009 25.25H12.5009Z",
    fill: "#5D616C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bellIcon.ca4629fef92113f85429575863818725.svg";
export { ForwardRef as ReactComponent };